import React from 'react'

const ViewStaff = () => {
    return (
        <div>
            <div className="modal fade" id="ViewstaffModal" tabindex="-1" aria-labelledby="ViewstaffModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                <div className="modal-content">
            <div className="modal-header">
                <h5 className="section-title" id="infoStaffModalLabel">Staff Information</h5>
                <button type="button" className="btn-close btn-close-primary size-10" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <div className="information-section">
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label htmlFor="userName" className="form-label">User Name</label>
                            <p id="userName">JohnDoe</p> {/* Replace with dynamic data */}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="password" className="form-label">Password</label>
                            <p id="password">********</p> {/* Replace with dynamic data */}
                        </div>
                        <div className="col-md-6 mt-3">
                            <label htmlFor="f_name" className="form-label">First Name</label>
                            <p id="f_name">John</p> {/* Replace with dynamic data */}
                        </div>
                        <div className="col-md-6 mt-3">
                            <label htmlFor="l_name" className="form-label">Last Name</label>
                            <p id="l_name">Doe</p> {/* Replace with dynamic data */}
                        </div>
                        <div className="col-md-6 mt-3">
                            <label htmlFor="phoneNo" className="form-label">Phone No</label>
                            <p id="phoneNo">+1234567890</p> {/* Replace with dynamic data */}
                        </div>
                        <div className="col-md-6 mt-3">
                            <label htmlFor="status" className="form-label">Status</label>
                            <p id="status">Active</p> {/* Replace with dynamic data */}
                        </div>
                        <div className="col-md-6 mt-3">
                            <label htmlFor="assignedProject" className="form-label">Assign Project</label>
                            <p id="assignedProject">SAI Branding</p> {/* Replace with dynamic data */}
                        </div>
                        <div className="col-md-6 mt-3">
                            <label htmlFor="role" className="form-label">Role</label>
                            <p id="role">Manager</p> {/* Replace with dynamic data */}
                        </div>
                        <div className="col-12 mt-3">
                            <label htmlFor="profile" className="form-label">Profile</label>
                            <p id="profile">profile_picture.jpg</p> {/* Replace with dynamic data */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer justify-content-between p-3" style={{ borderTop: "2px solid #f0f0f0" }}>
                <button
                    type="button"
                    className="btn btn-outline-primary d-flex align-items-center gap-2"
                    style={{ borderRadius: "30px", padding: "0.5rem 1.5rem" }}
                    data-bs-dismiss="modal"
                >
                    <i className="bi bi-x-circle"></i> Close
                </button>
                <button
                    type="button"
                    className="btn btn-gradient d-flex align-items-center gap-2"
                    style={{ borderRadius: "30px", padding: "0.5rem 1.5rem", background: "linear-gradient(90deg, #6a11cb 0%, #313265 100%)", color: "white", border: "none" }}
                >
                    <i className="bi bi-pencil-square"></i> Edit
                </button>
            </div>
        </div>
                </div>
            </div>




        </div>
    )
}

export default ViewStaff
